import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const NetworkGuard = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      toast.error('No Internet Connection! Navigation blocked.');
    };

    const handleOnline = () => {
      setIsOnline(true);
      toast.success('Internet Connection Restored!');
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  useEffect(() => {
    if (!isOnline) {
      const preventNav = e => {
        // Catch clicks on <a>, <button>, <input type="submit">, or elements with role="link"/"button"
        const target = e.target.closest(
          "a, button, input[type='submit'], [role='link'], [role='button']"
        );
        if (target) {
          e.preventDefault();
          e.stopPropagation();
          toast.error('You are offline. Navigation blocked.');
        }
      };

      document.addEventListener('click', preventNav, true);

      return () => document.removeEventListener('click', preventNav, true);
    }
  }, [isOnline]);

  return (
    !isOnline && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          backgroundColor: 'red',
          color: 'white',
          textAlign: 'center',
          padding: '8px',
          zIndex: 9999,
          fontWeight: 'bold',
        }}
      >
        No Internet Connection
      </div>
    )
  );
};

export default NetworkGuard;
